import { Link } from "office-ui-fabric-react";

const AiInsightsSettingsTooltip = () => <div>
    PPM Insights AI provides users with direct access to AI-powered features within PPM Express.
    Please refer to the <Link href="https://help.ppm.express/ppm-insights-ai" target="_blank">article</Link> for more details.
</div>

export default AiInsightsSettingsTooltip;